var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('span',[_c('b-button',{class:_vm.cssColor,attrs:{"icon-right":_vm.iconEmail,"reads":_vm.reads,"unreads":_vm.unReads},on:{"click":function($event){$event.preventDefault();return _vm.openBox(_vm.ids)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63cc0361","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MailBox.vue
// module id = null
// module chunks = 